import React from "react";
import "./App.css";
// import { useTranslation } from "react-i18next";
import TbaTemplateWizard from "./Components/TbaTemplateWizard";

const TbaTemplateForm = () => {
  // const { t } = useTranslation();

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };

return <TbaTemplateWizard />;
};

export default TbaTemplateForm;
